@if (sections.length > 0) {
  <div class="section-viewer-layout">
    <aside class="section-menu">
      <mat-nav-list class="section-nav-list">
        @for (section of sortedSections; track section.id) {
          <a
            mat-list-item
            class="section-nav-item"
            [class.active]="section.id === activeSectionId"
            (click)="selectSection(section)">
            <span matListItemTitle>{{ section.title | translate }}</span>
          </a>
        }
      </mat-nav-list>
    </aside>

    <main class="section-viewer-main">
      @if (readOnly) {
        <div class="section-html-readonly help-content-html" [innerHTML]="sanitizedContent"></div>
      } @else {
        @for (section of [activeSection]; track section.id) {
          <app-html-editor
            [inline]="true"
            [formControlEditing]="formControlEditing"
            [data]="section.content">
          </app-html-editor>
        }
      }
    </main>
  </div>
} @else {
  <p class="empty-sections">{{ 'help-section-select' | translate }}</p>
}
